import React, { useState } from "react"
import {
  GalleryItem,
  GalleryBox,
  Image,
  GalleryWrapper,
  GalleryModal,
  LgImage,
} from "./styled"

const Gallery = ({ queryData }) => {
  const [showLgImage, setShowImage] = useState(false)
  const closeLgImg = () => setShowImage(false)

  return (
    <>
      {showLgImage !== false && (
        <GalleryWrapper onClick={closeLgImg}>
          <GalleryModal>
            <LgImage
              fluid={queryData[showLgImage].node.childImageSharp.fluid}
              imgStyle={{ objectFit: "contain" }}
            />
          </GalleryModal>
        </GalleryWrapper>
      )}
      <GalleryBox>
        {queryData.map((img, key) => (
          <GalleryItem onClick={() => setShowImage(key)}>
            <Image key={key} fluid={img.node.childImageSharp.fluid} />
          </GalleryItem>
        ))}
      </GalleryBox>
    </>
  )
}

export default Gallery
